import { useState } from "react";
import { Lock, Coins, ArrowRight, X } from "lucide-react";
import PlansPanel from "@/components/billing/PlansPanel";

/* Reusable pay-to-play paywall. Shows the Credit shortfall for a gated action
   and routes the operator straight into the live Stripe credits storefront. */
export default function CreditPaywall({ detail, onClose }) {
  const [showPlans, setShowPlans] = useState(false);
  if (!detail) return null;
  if (showPlans) return <PlansPanel onBack={onClose} />;

  const { cost, balance, shortfall, message } = detail;
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/75 p-6" data-testid="credit-paywall" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-[300px] max-w-[calc(100vw-32px)] rounded-3xl border-4 border-gold bg-slate-950 p-5 text-center shadow-[6px_6px_0px_#000] relative">
        <button onClick={onClose} data-testid="credit-paywall-close" className="absolute right-3 top-3 grid h-7 w-7 place-items-center rounded-full border border-white/20 bg-white/5"><X size={13} className="text-white/60" /></button>
        <span className="mx-auto mb-3 grid h-14 w-14 place-items-center rounded-2xl border-2 border-gold bg-gold/15"><Lock size={24} className="text-gold" /></span>
        <h3 className="font-serif text-2xl leading-tight text-white">Unlock This Action</h3>
        <p className="mt-2 font-mono text-[10px] leading-relaxed text-white/60">
          {message || "You need more Credits to continue."}
        </p>
        <div className="mt-4 grid grid-cols-3 gap-2" data-testid="credit-paywall-meter">
          {[["Cost", `${cost} Cr`], ["Balance", `${balance} Cr`], ["Short", `${shortfall} Cr`]].map(([k, v]) => (
            <div key={k} className="rounded-xl border-2 border-white/10 bg-white/5 py-2">
              <p className="font-mono text-[7px] uppercase tracking-widest text-white/40">{k}</p>
              <p className="font-mono text-[11px] font-black text-gold">{v}</p>
            </div>
          ))}
        </div>
        <button onClick={() => setShowPlans(true)} data-testid="credit-paywall-topup" className="mt-4 flex w-full items-center justify-center gap-2 rounded-full border-2 border-charcoal bg-gold py-3 font-mono text-[10px] font-black uppercase tracking-widest text-black shadow-[3px_3px_0px_#000] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none">
          <Coins size={14} /> Top Up Credits <ArrowRight size={14} />
        </button>
        <button onClick={onClose} data-testid="credit-paywall-later" className="mt-2 w-full py-2 font-mono text-[9px] uppercase tracking-widest text-white/40">Maybe later</button>
      </div>
    </div>
  );
}
